import Spinner from "../spinner/Spinner";
import styles from "./FullPageLoader.module.scss";

const FullscreenLoader = () => {
  return (
    <div className={styles.loaderOverlay}>
      <Spinner />
    </div>
  );
};

export default FullscreenLoader;
